<table *ngIf="kfRegistrationDetail" class="kf-registration-table" mat-table [dataSource]="kfRegistrationDetail.categories">
  <ng-container matColumnDef="entry">
    <th mat-header-cell *matHeaderCellDef>Entry</th>
    <td mat-cell *matCellDef="let category; let i = index" >
      {{categories[i].description}}
      <span>{{category.kind}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef> Total </td>
  </ng-container>
  <ng-container matColumnDef="pieces">
    <th mat-header-cell *matHeaderCellDef>Pieces</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.piecesDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.piecesDifferentValueAllowed ? 'value-exceeded' : ''">{{item.piecesValue | number}} </span>
      <span class="value-exceeded" *ngIf="item.piecesDifferentValueAllowed">*</span>
    </td>
    <td mat-footer-cell *matFooterCellDef> {{totalPieces | number}} </td>
  </ng-container>
  <ng-container matColumnDef="tons">
    <th mat-header-cell *matHeaderCellDef>Tons</th>
    <td mat-cell *matCellDef="let item"
        [matTooltip]="item.tonsDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
      <span [className]="item.tonsDifferentValueAllowed ? 'value-exceeded' : ''">{{item.tonsValue | number: '1.2-2' }} </span>
      <span class="value-exceeded" *ngIf="item.tonsDifferentValueAllowed">*</span>
    </td>
    <td mat-footer-cell *matFooterCellDef> {{totalTons | number: '1.2-2' }} </td>
  </ng-container>
  <ng-container matColumnDef="remark">
    <th mat-header-cell *matHeaderCellDef>Remark</th>
    <td mat-cell *matCellDef="let item"> {{item.remark}} </td>
    <td mat-footer-cell *matFooterCellDef> </td>
  </ng-container>

  <ng-container matColumnDef="b2bFooter" *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'" >
    <td mat-footer-cell *matFooterCellDef> Subtotal B2B </td>
  </ng-container>
  <ng-container matColumnDef="b2cFooter" *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'" >
    <td mat-footer-cell *matFooterCellDef> Subtotal B2C </td>
  </ng-container>
  <ng-container matColumnDef="totalB2BPieces" *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'">
    <td mat-footer-cell *matFooterCellDef> {{subTotalPiecesB2B | number}} </td>
  </ng-container>
  <ng-container matColumnDef="totalB2CPieces" *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'">
    <td mat-footer-cell *matFooterCellDef> {{subTotalPiecesB2C | number}} </td>
  </ng-container>
  <ng-container matColumnDef="totalB2BTons" *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'">
    <td mat-footer-cell *matFooterCellDef> {{subTotalTonsB2B | number}} </td>
  </ng-container>
  <ng-container matColumnDef="totalB2CTons" *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'">
    <td mat-footer-cell *matFooterCellDef> {{subTotalTonsB2C | number}} </td>
  </ng-container>
  <ng-container matColumnDef="remarkB2B" *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'">
    <td mat-footer-cell *matFooterCellDef> </td>
  </ng-container>
  <ng-container matColumnDef="remarkB2C" *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'">
    <td mat-footer-cell *matFooterCellDef> </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  <ng-container *ngIf="kfRegistrationDetail.kfRegistration.detailLevel == 'DIFFERENTIATED'">
    <tr mat-footer-row *matFooterRowDef="b2bFooter"></tr>
    <tr mat-footer-row *matFooterRowDef="b2cFooter"></tr>
  </ng-container>
  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
</table>
